import {ReactElement, useEffect, useState} from "react"
import {unstable_batchedUpdates} from 'react-dom';
import {observer} from "mobx-react-lite"
import {notification} from "antd"
import {t} from "@ui/common/intl"
import {useStore} from "@ui/stores"
import {MenuItemProps} from "@ui/components/services/menu"
import Main from "./main"
import View from "./View"
import New from "./New"
import Save from "./Save"

export enum PoiPage {
  Main,
  View,
  New,
  Save
}

export type TPoiPageProps = {
  goto: (page: PoiPage, param?: any) => void
  param?: any
	close: () => void
  isShow: boolean
  notifyError: (intlKey: string, error?: any) => void
}

const Poi = ({isShow, close, open}: MenuItemProps): ReactElement => {
  const [notify, contextHolder] = notification.useNotification()
  const [page, setPage] = useState(PoiPage.Main)
  const [param, setParam] = useState()
  const {poi} = useStore()

  useEffect(() => {
    if (poi.selected && (!isShow || page !== PoiPage.View)) {
      open()
      goto(PoiPage.View, {id: poi.selected})
    }
  }, [poi.selected])

  const notifyError = (intlKey: string, error?: any) => {
    // @todo реализовать показ диалога об ошибке
    notify?.error({
      message: t(intlKey, error ? {error: error && error.message || (error.data && (error.data.detail || JSON.stringify(error.data)))} : {}),
      placement: 'top',
      className: "error-notification"
    })
  }

  const goto = (page: PoiPage, param?: any) => {
    unstable_batchedUpdates(() => {
      setParam(param)
			setPage(page)
    })
  }

  const props: TPoiPageProps = {goto, close, isShow, notifyError}

  const getPage = (props: TPoiPageProps) => {
		switch (page) {
			case PoiPage.Main:
				return <Main {...props} />
			case PoiPage.View:
				return <View {...props} />
      case PoiPage.New:
				return <New {...props} />
      case PoiPage.Save:
				return <Save {...props} />
			default:
				return <></>
		}
	}

  return (
    <div className="poi">
      {contextHolder}
      {getPage({...props, param})}
    </div>
  )
}

export default observer(Poi)
